import React, { useContext } from 'react'
import styled from 'styled-components'
import { Form, Field } from 'react-final-form'
import moment from 'moment'

import { required } from '../../utils/validation'
import { AppContext } from '../App'
import DatePicker, { DATE_FORMAT } from '../../components/DatePicker/DatePicker'
import Modal from '../Modal'
import Button from '../../components/Button'
import { flexBoxStyles } from '../../components/Flexbox'

export const EXAMINATION_ENDPOINT = '/diagnostic/rest/examination'

const DiagnosisModal = ({
  id,
  onClose,
  isOpen,
  refetchData,
  handleTabsChange,
  dateOfBirth,
}) => {
  const { withAuth } = useContext(AppContext)
  const newDateOfBirth = new Date(dateOfBirth)
  const minimalDiagnosisDate = new Date(
    newDateOfBirth.setMonth(newDateOfBirth.getMonth() + 3)
  )
  const maximalDiagnosisDate = new Date(
    newDateOfBirth.setFullYear(newDateOfBirth.getFullYear() + 25)
  )
  const submit = async (values) => {
    try {
      await withAuth(EXAMINATION_ENDPOINT, {
        method: 'POST',
        payload: {
          ...values,
        },
      })
      refetchData()
    } catch {}
    onClose()
    handleTabsChange(1)
  }

  return (
    <Modal
      id="layout"
      isOpen={isOpen}
      onClose={onClose}
      closer={true}
      title="Nowa diagnoza"
    >
      <Form
        initialValues={{
          expectedDate: moment().format(DATE_FORMAT),
          note: '',
          patientId: id,
        }}
        onSubmit={submit}
      >
        {({ handleSubmit }) => (
          <>
            <Field
              label="Wybierz datę badania"
              name="expectedDate"
              component={DatePicker}
              minDate={moment(minimalDiagnosisDate)}
              maxDate={moment(maximalDiagnosisDate)}
              validate={required}
            />
            <Footer justify="space-between">
              <Button label="Zapisz" type="submit" onClick={handleSubmit} />
            </Footer>
          </>
        )}
      </Form>
    </Modal>
  )
}

const Footer = styled.div`
  ${flexBoxStyles};
  &::before {
    position: absolute;
    left: 0;
    bottom: 7rem;
    content: '';
    border-bottom: 1px solid #eee;
    width: 100%;
  }
`

export default DiagnosisModal
